import Component from "@ember/component"
import { computed } from "@ember/object"
import PromiseProxyMixin from "@ember/object/promise-proxy-mixin"
import ObjectProxy from "@ember/object/proxy"
import { inject as service } from "@ember/service"
import type { Course } from "@shared/models/course"
import findMany from "cc-frontend/helpers/find-many"
import type AppState from "cc-frontend/services/app-state"
import type EmberStore from "cc-frontend/services/ember-store"
import { find } from "lodash-es"

export default class UnitProvider extends Component {
  // args
  course!: Course
  unitId!: string

  //state
  showStandardsModal = false
  sectionState = {}
  menuIsOpen = false
  isExpanded = true

  @service("ember-store") store!: EmberStore
  @service appState!: AppState

  // relationships
  @findMany("unitInfo.ancestorIds", "card-stack-summary") units
  // CPs
  @computed("unitId")
  get unit() {
    class ObjectPromiseProxy extends ObjectProxy.extend(PromiseProxyMixin) {}

    let promise = this.store.find("card-stack", this.unitId)
    return ObjectPromiseProxy.create({ promise: promise })
  }

  @computed("course.attributes.calendar.version", "unitId")
  get unitInfo() {
    return find(this.course.attributes.calendar.units, {
      id: this.unitId,
    })
  }
}
